import React, { useState } from "react";
import Button from "components/CustomButton";
import Scrollbar from "react-scrollbars-custom";
import { ReactComponent as SurveyIcon } from "assets/img/survey_icon.svg";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import "assets/scss/partials/microsoftTeams.scss";
import WellnessSurvey from "views/Survey/WellnessSurvey";

export default () => {
  const [dialog, setDialog] = useState(false);

  const openTodoListDialog = () => {
    setDialog(true);
  };

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamTodoListButton"
        onClick={openTodoListDialog}
      >
        <SurveyIcon style={{ fill: "white", width: "24px" }} />
        Survey
      </Button>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
          {" "}
          Survey
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div className="pollListContent">
          <Scrollbar style={{ height: "calc(100vh - 100px)" }}>
            <div>
              <div>
                <WellnessSurvey />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
